var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.28 2.66667C19.2 3.85333 19 5.01333 18.68 6.12L20.28 7.72C20.8267 6.12 21.1733 4.42667 21.2933 2.66667H19.28ZM6.13333 18.6933C5 19.0133 3.84 19.2133 2.66667 19.2933V21.28C4.42667 21.16 6.12 20.8133 7.73333 20.28L6.13333 18.6933ZM18 0H22.6667C23.4 0 24 0.6 24 1.33333C24 13.8533 13.8533 24 1.33333 24C0.6 24 0 23.4 0 22.6667V18.0133C0 17.28 0.6 16.68 1.33333 16.68C2.98667 16.68 4.6 16.4133 6.09333 15.92C6.22667 15.8667 6.37333 15.8533 6.50667 15.8533C6.85333 15.8533 7.18667 15.9867 7.45333 16.24L10.3867 19.1733C14.16 17.24 17.2533 14.16 19.1733 10.3867L16.24 7.45333C15.8667 7.08 15.76 6.56 15.9067 6.09333C16.4 4.6 16.6667 3 16.6667 1.33333C16.6667 0.6 17.2667 0 18 0Z","fill":"white"}));
}

Phone.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
